import { gql } from "@apollo/client"

export const RESET_PASSWORD = gql`
  mutation ResetPasswordRequest($email: String!) {
    requestResetPassword(email: $email)
  }
`
